import { load } from 'recaptcha-v3'

export default () => {
  const executeRecaptcha = async (action: string) => {
    const { recaptchaSiteKey } = useRuntimeConfig().public
    const recaptcha = await load(recaptchaSiteKey, {
      autoHideBadge: true
    })
    const token = await recaptcha.execute(action)
    return token
  }
  return { executeRecaptcha }
}